import React from "react";
import { Platform, Pressable, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { SOCIAL_MEDIA_ICONS } from "./SocialMedia";

import { type Link } from "@/schemas/links/web";

type Props = {
  link: Link;
};

function LinkIcon({ link }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    socialButton: {
      width: 44,
      height: 44,
      borderRadius: 22,
      justifyContent: "center",
      alignItems: "center",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
    },
  });

  const icon = SOCIAL_MEDIA_ICONS[link.type];

  const openLink = (): void => {
    if (Platform.OS === "web") {
      window.open(link.url, "_blank");
    }
  };

  return (
    <Pressable
      style={[styles.socialButton, { backgroundColor: icon.color }]}
      onPress={() => openLink()}
    >
      <MaterialCommunityIcons name={icon.iconName} size={30} color="#FFFFFF" />
    </Pressable>
  );
}

export default LinkIcon;
